import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { ApiService } from '../services/api.service'
import { AuthService } from '../services/auth.service'

export const adminScopeGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService)
  const apiService = inject(ApiService)
  const router = inject(Router)

  const user = authService.getStoredUser('admin')
  if (!user) return router.createUrlTree(['/admin-login'])

  if (user.role === 'super-admin') return true
  if (user.role !== 'admin' && user.role !== 'seller') return router.createUrlTree(['/'])

  const tab = route.paramMap.get('tab')
  if (tab && tab !== 'stores') {
    return router.createUrlTree(['/'])
  }

  if (route.routeConfig?.path === 'admin') {
    return true
  }

  const username = route.paramMap.get('username')
  if (!username) return router.createUrlTree(['/'])

  return apiService.getStores({ username }).pipe(
    map(stores => {
      const canAccessStore = stores.some(store => store.username === username)
      if (canAccessStore) return true
      return router.createUrlTree(['/'])
    }),
    catchError(() => of(router.createUrlTree(['/'])))
  )
}
